if (typeof boostPFSThemeConfig !== 'undefined') {
	// Override Settings
	var boostPFSFilterConfig = {
		general: {
			limit: boostPFSConfig.custom.products_per_page,
			loadProductFirst: false,
			numberFilterTree: 2,
			selectOptionContainer: '.grid__item .card-wrapper',
			stickyFixTopPos: true,
            requestInstantly: true,
            oneValueRangeSlider: true,
		},
		selector: {
			otpTopCartCount: '.cart-count-bubble'
		}
	};
}
// BoostPFS.Labels.refineMobile = 'Fiter & Sort';
// Fix the confict suggestion search in Debut theme
if (typeof theme !== 'undefined' && theme.hasOwnProperty('settings')) theme.settings.predictiveSearchEnabled = false;
const productJson = document.querySelector('#product-pricing') ? JSON.parse(document.querySelector('#product-pricing').textContent) : [];

(function () {
	var onSale = false,
		soldOut = false,
		priceVaries = false,
		images = [],
		boostPFSRangeWidths = [165, 360, 533, 720, 940, 1066];


	BoostPFS.inject(this);

	/************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	function prepareShopifyData(data) {
		// Displaying price base on the policy of Shopify, have to multiple by 100
		soldOut = !data.available; // Check a product is out of stock
		onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Convert images to array
		images = data.images_info;
		// Get First Variant (selected_or_first_available_variant)
		firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function (e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}      
		return data;
	}

	/************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	/************************** BUILD PRODUCT LIST **************************/
	// Build Product Grid Item
	ProductGridItem.prototype.compileTemplate = function (data) {
		if (!data) data = this.data;
		
		// Customize API data to get the Shopify data
		data = prepareShopifyData(data);
		
		// Get Template
		var itemHtml = boostPFSTemplate.productGridItemHtml;
   
		/* SPLIT PRODUCT CARDS INTO ALL COLORS */
		if(data.tags.includes("split-colors")){
			let itemsHTML = "";
			var hascolorOption = data.options_with_values.find(item => item.name.toLowerCase() === 'color');
			if(hascolorOption){
				var colorOption = hascolorOption.values;
				colorOption.forEach(item => {
					itemsHTML += cloneProductGridItem(data, item.title);
				})
			}
			return itemsHTML;
		}

		// Add Custom class
		var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
		var saleClass = onSale ? boostPFSTemplate.saleClass : '';
		let customSaleClass = onSale ? "on_sale" : '';
    
        if(data.tags.includes("Black Friday")){
            customSaleClass += " on_sale";
        }
		itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);

		itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);

		// Add Card product class
		itemHtml = itemHtml.replace(/{{cardProductClass}}/g, buildCardProductClass());
		// Add sold out Label
		itemHtml = itemHtml.replace(/{{itemSoldOut}}/g, buildSoldOutLabel());
		// Add sale Label
		itemHtml = itemHtml.replace(/{{itemSale}}/g, buildSaleLabel());
		// Add Images
// 		itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
      	itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, Utils.getFeaturedImage(images, '350x350'));
        const hoverImg = data.images_info.find(img => img.alt && img.alt.includes('Collection-Hover'))
        if(hoverImg){
          itemHtml = itemHtml.replace(/{{itemHoverImg}}/g, buildHoverImage(hoverImg));
        }else{
          itemHtml = itemHtml.replace(/{{itemHoverImg}}/g, "");
        }
		// Add Price
		var priceDisplayMetafield = Utils.getProductMetafield(this.data , 'my_fields' , 'no_price_on_concept2');
      
        var priceShouldBeDisplayed = priceDisplayMetafield == null || priceDisplayMetafield === "false";
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, !priceShouldBeDisplayed || data.template_suffix == 'BW-Product-new-3kit' ? '' : buildPrice(data));
       
    
        // Add Item Stock
        itemHtml = itemHtml.replace(/{{itemStock}}/g, data.available ? 'In Stock' : 'Out Of Stock');
      
		// Add Review
		if (typeof Integration === 'undefined' ||
			(typeof Integration != 'undefined' &&
				typeof Integration.hascompileTemplate == 'function' &&
				!Integration.hascompileTemplate('reviews'))) {
			itemHtml = itemHtml.replace(/{{itemReviews}}/g, buildReview(data));
		}

		// Add Vendor
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, data.vendor);
      
      	// Add cart form
      	var itemCartHtml = '';
      	var build_product = false;
        var buildRackTag = data.tags.filter(function(e) {
			return e.indexOf('Build Rack') !== -1;
        });
        let isPreorder = data.metafields.find(mf => mf.namespace === 'rep' && mf.key === 'pre_available_us_quantity');
      
        
        if (typeof buildRackTag[0] !== 'undefined') build_product = true;
		let deals = "";
		if(data.tags.includes("closeout")){
			deals = `<div class="closeout-container absolute bottom-[10px] py-[10px] leading-none	 font-semibold left-0 w-full bg-black text-center text-white"><span>CLOSEOUT</span></div>`;
		}
        if(data.tags.includes("New")){
			deals = `<div class="closeout-container absolute bottom-[10px] py-[10px] leading-none	 font-semibold left-0 w-full bg-black text-center text-white"><span>NEW</span></div>`;
		}
        if (data.available) {
          if (!data.tags.includes('parentItem')) {
            itemCartHtml += '<div class="product__grid__new_options">';
            itemCartHtml += '<div class="product-form__buttons coll_new_gr_cart_btn">';
            if (build_product) {
              itemCartHtml += '<a href="{{itemUrl}}" class="btn_commoncls borderzero product-form__submit">Build It</a>';
            } else if(isMultipleOption(data) || !soldOut && data.tags.includes('Threekit') || !soldOut && isMultipleOption(data) || isPreorder || data.tags.includes('disable-quickadd')){
              itemCartHtml += '<a href="{{itemUrl}}" class="btn_commoncls borderzero product-form__submit">Customize Now</a>';
            } else {
              var variantId = data.variants[0]['id'];
              if (Globals.queryParams.hasOwnProperty('pf_opt_color')) {
                var selectedColor = Globals.queryParams.pf_opt_color[0];
                var colorVariant = data.variants.filter(function(e) {
                  return e.option_color == selectedColor;
                });
                if (typeof colorVariant[0] !== 'undefined') variantId = colorVariant[0]['id'];
              }
              
              /* start-boost-custom */
              /* #boost-125365: hide add to cart if variant not avaialble to CA */
              var showATC = true;
              var isDisabled = soldOut //|| !showATC;
              var statusClass = isDisabled ? 'disabled' : '';
              
              itemCartHtml += '<button ' + (isDisabled ? 'type="button"' : 'type="submit"') + ' name="add" data-id="' + variantId + '" class="btn_commoncls borderzero product-form__submit ' + (isDisabled ? '' : 'short_cut_add_tocart') + '" ' + statusClass + '><span>';
              if (!soldOut && data.tags.includes('Threekit') || !soldOut && isMultipleOption(data) || data.tags.includes('disable-quickadd')) {
                itemCartHtml += 'Customize now';
              } else if (isDisabled) {
                itemCartHtml += 'Sold Out';
              } else {
                itemCartHtml += 'Quick add';
              }
              //itemCartHtml += isDisabled ? 'Sold Out' : 'Quick add';
              itemCartHtml += '</span></button>';

              /* end-boost-custom */
            }

            itemCartHtml += '</div>';
            if(!isMultipleOption(data)){
              if (data.variants.length > 1 || (data.variants.length == 1 && data.variants[0]['title'] != 'Default title')) {
                for (var i = 0; i < data.options_with_values.length; i++) {
                  var option = data.options_with_values[i];
                  var optionName = option.name.toLowerCase();
                  var isOnlyHasOneAvailable = 0;
                  var isDefaultTitle = false;
                  for (var m = 0; m < data.variants.length; m++) {
                    if(data.variants[m].available){
                      isOnlyHasOneAvailable++;
                    }
                    if(data.variants[m].title == 'Default Title' || data.variants[m].title == 'default title'){
                      isDefaultTitle = true;
                    }
                  }
                  var hideIfOnlyHasOneAvailable = '';
                  if(isOnlyHasOneAvailable <= 1 && isDefaultTitle){
                    hideIfOnlyHasOneAvailable = 'only-one';
                  }
                  
                  //if (optionName.indexOf('color') !== -1 || optionName.indexOf('colour') !== -1 || optionName.indexOf('series') !== -1 || optionName.indexOf('size') !== -1) {
                  itemCartHtml += '<ul class="product__color_option_ul '+ optionName +' '+ hideIfOnlyHasOneAvailable +'">';
                  var values = [];
                  var isFirstAvailable = 0;
                  for (var j = 0; j < data.variants.length; j++) {
                    /* start-boost-custom */                    
                    var variant = data.variants[j];
                    var isAvailable = true;
                    if (window.location.host.startsWith('ca.')) {
                      if (variant.available_locations && !variant.available_locations.includes(65512734878)) {
                        isAvailable = false;
                      }
                      if (variant.inventory_policy = "continue" && data.locations.includes("all:Carlisle, PA Warehouse")) {
                        isAvailable = true;
                      }
                    }
                    
                    var colorOption = variant['option_' + Utils.slugify(optionName)];
                    if (!values.includes(colorOption) && isAvailable) {
                      /* start-boost-custom */
                      
                      var colorArray = colorOption.split(',');
                      var color = (colorArray[colorArray.length - 1] || '').trim();
                  
                      var swatchSettingStyle = 'background-color:'+color.toLowerCase()+';';
                      var swatchSettings = Settings.getSettingValue('swatch_settings');
                      if(typeof(swatchSettings) !== 'undefined' && typeof(swatchSettings[color.toLowerCase()]) !== 'undefined' && typeof(swatchSettings[color.toLowerCase()]['imageUrl']) !== 'undefined' && swatchSettings[color.toLowerCase()]['imageUrl'] !== '' && swatchSettings[color.toLowerCase()]['imageUrl'] !== null){
                        //console.log(swatchSettings[color.toLowerCase()]['imageUrl']);
                        swatchSettingStyle += ' background-image: url('+ swatchSettings[color.toLowerCase()]['imageUrl'] +'); background-size: contain;';
                      }

                      if(variant.available){
                        isFirstAvailable++;
                      }
                      if(isFirstAvailable == 1){
                        itemCartHtml += '<li class="'+variant.available+' active">';
                      }else{
                        itemCartHtml += '<li class="'+variant.available+'">';
                      }
                      itemCartHtml += '<div class="pro__var_div" style="'+ swatchSettingStyle +'" data-title="'+ variant.title +'">';
                      if (isAvailable) {
                        itemCartHtml += '<div type="submit" name="add" data-id="' + variant.id + '" data-image="' + variant.image + '" class="short_cut_add_tocart__collection" >';
                      } else {
                        itemCartHtml += '<div data-id="' + variant.id + '" data-image="' + variant.image + '" class="not_available_in_ca">';
                      }
                      itemCartHtml += variant.title;

                      /* #boost-125010: fix swatches */
                      /* for (var k = 0; k < boostPFSThemeConfig.variant_blocks.length; k++) {
                          var pro__color_var = boostPFSThemeConfig.variant_blocks[k]['variant__text'];
                          if (colorOption == pro__color_var) {
                            itemCartHtml += '<img src="' + Utils.optimizeImage(boostPFSThemeConfig.variant_blocks[k]['variant__image'], '35x') + '">';
                          }
                      } */
                      /* end-boost-custom */ 
                      itemCartHtml += '</div>';
                      itemCartHtml += '</div>';
                      itemCartHtml += '</li>';
                      values.push(colorOption);
                    }
                  }
                  itemCartHtml += '</ul>';
                }
              }
            }
          }
        } else {
          if(data.tags.includes('Coming Soon')){
            itemCartHtml += '<div class="product__grid__new_options">';
            itemCartHtml += '<div class="product-form__buttons coll_new_gr_cart_btn">';
            itemCartHtml += '<a href="{{itemUrl}}" class="btn_commoncls borderzero product-form__submit">Coming Soon</a>';
            itemCartHtml += '</div>';
          }else if(data.tags.includes('Request Pricing')){
            itemCartHtml += '<div class="product__grid__new_options">';
            itemCartHtml += '<div class="product-form__buttons coll_new_gr_cart_btn">';
            itemCartHtml += '<button type="button" name="add" class="btn_commoncls borderzero product-form__submit"><span>';
            itemCartHtml += 'Request Pricing';
            itemCartHtml += '</span></button>';
            itemCartHtml += '</div>';
          }else if(data.tags.includes('hide-sold-out')){
          }else{
            itemCartHtml += '<div class="product__grid__new_options">';
            itemCartHtml += '<div class="product-form__buttons coll_new_gr_cart_btn">';
            itemCartHtml += '<button type="button" name="add" class="btn_commoncls borderzero product-form__submit" disabled><span>';
            itemCartHtml += 'Sold Out';
            itemCartHtml += '</span></button>';
            itemCartHtml += '</div>';
          }
        }
        itemCartHtml += '</div>';

		

		//BUILD PROGRESS BAR 
		 //let progressBar = buildProgressBar(data);
		 let progressBar = '';
		itemHtml = itemHtml.replace(/{{progressBar}}/g, progressBar);
      	itemHtml = itemHtml.replace(/{{itemCart}}/g, Utils.isSearchPage() ? '' : itemCartHtml);

		// Add main attribute (Always put at the end of this function)
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
		itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));
		itemHtml = itemHtml.replace(/{{itemCustomSale}}/g, customSaleClass); 
		itemHtml = itemHtml.replace(/{{itemDeals}}/g, deals);  

		
		return itemHtml;
	};

	function cloneProductGridItem(data, color) {
		const selectedVariant = data.variants.find(variant => variant.options.find(option => option == color));
		if (!selectedVariant) return '';
		
		var itemHtml = boostPFSTemplate.productGridItemHtml;
		// Add Custom class
		var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
		var saleClass = onSale ? boostPFSTemplate.saleClass : '';
		let customSaleClass = onSale ? "on_sale" : '';
    
        if(data.tags.includes("Black Friday")){
            customSaleClass += " on_sale";
        }
		itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);

		itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);

		// Add Card product class
		itemHtml = itemHtml.replace(/{{cardProductClass}}/g, buildCardProductClass());
		// Add sold out Label
		itemHtml = itemHtml.replace(/{{itemSoldOut}}/g, buildSoldOutLabel());
		// Add sale Label
		itemHtml = itemHtml.replace(/{{itemSale}}/g, buildSaleLabel());
		// Add Images
// 		itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
      	itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, selectedVariant.image);
        const hoverImg = data.images_info.find(img => img.alt && img.alt.includes('Collection-Hover'))
        if(hoverImg){
          itemHtml = itemHtml.replace(/{{itemHoverImg}}/g, buildHoverImage(hoverImg));
        }else{
          itemHtml = itemHtml.replace(/{{itemHoverImg}}/g, "");
        }
		// Add Price
		//var priceDisplayMetafield = Utils.getProductMetafield(this.data , 'my_fields' , 'no_price_on_concept2');
        var priceShouldBeDisplayed = true;
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, !priceShouldBeDisplayed || data.template_suffix == 'BW-Product-new-3kit' ? '' : buildPrice(data));
       
    
        // Add Item Stock
        itemHtml = itemHtml.replace(/{{itemStock}}/g, data.available ? 'In Stock' : 'Out Of Stock');
      
		// Add Review
		if (typeof Integration === 'undefined' ||
			(typeof Integration != 'undefined' &&
				typeof Integration.hascompileTemplate == 'function' &&
				!Integration.hascompileTemplate('reviews'))) {
			itemHtml = itemHtml.replace(/{{itemReviews}}/g, buildReview(data));
		}

		// Add Vendor
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, data.vendor);
      
      	// Add cart form
      	var itemCartHtml = '';
      	var build_product = false;
        var buildRackTag = data.tags.filter(function(e) {
			return e.indexOf('Build Rack') !== -1;
        });
        let isPreorder = data.metafields.find(mf => mf.namespace === 'rep' && mf.key === 'pre_available_us_quantity');
      
        
        if (typeof buildRackTag[0] !== 'undefined') build_product = true;
		let deals = "";
		if(data.tags.includes("closeout")){
			deals = `<div class="closeout-container absolute bottom-[10px] py-[10px] leading-none	 font-semibold left-0 w-full bg-black text-center text-white"><span>CLOSEOUT</span></div>`;
		}
        if(data.tags.includes("New")){
			deals = `<div class="closeout-container absolute bottom-[10px] py-[10px] leading-none	 font-semibold left-0 w-full bg-black text-center text-white"><span>NEW</span></div>`;
		}

        
        if (data.available) {
        itemCartHtml += '<div class="product__grid__new_options">';
        itemCartHtml += '<div class="product-form__buttons coll_new_gr_cart_btn">';
          if (build_product) {
            	itemCartHtml += '<a href="{{itemUrl}}" class="btn_commoncls borderzero product-form__submit">Build It</a>';
          } else if(isMultipleOption(data) || !soldOut && data.tags.includes('Threekit') || !soldOut && isMultipleOption(data) || isPreorder || data.tags.includes('disable-quickadd')){
                itemCartHtml += '<a href="{{itemUrl}}" class="btn_commoncls borderzero product-form__submit">Customize Now</a>';
          } else {
            	var variantId = data.variants[0]['id'];
              if (Globals.queryParams.hasOwnProperty('pf_opt_color')) {
  				var selectedColor = Globals.queryParams.pf_opt_color[0];
                  var colorVariant = data.variants.filter(function(e) {
                    	return e.option_color == selectedColor;
                  });
                	if (typeof colorVariant[0] !== 'undefined') variantId = colorVariant[0]['id'];
              }
            
              /* start-boost-custom */
              /* #boost-125365: hide add to cart if variant not avaialble to CA */
              var showATC = true;
              var isDisabled = soldOut //|| !showATC;
              var statusClass = isDisabled ? 'disabled' : '';
              
              itemCartHtml += '<button ' + (isDisabled ? 'type="button"' : 'type="submit"') + ' name="add" data-id="' + variantId + '" class="btn_commoncls borderzero product-form__submit ' + (isDisabled ? '' : 'short_cut_add_tocart') + '" ' + statusClass + '><span>';
              if (!soldOut && data.tags.includes('Threekit') || !soldOut && isMultipleOption(data) || data.tags.includes('disable-quickadd')) {
                itemCartHtml += 'Customize now';
              } else if (isDisabled) {
                itemCartHtml += 'Sold Out';
              } else {
                itemCartHtml += 'Quick add';
              }
              //itemCartHtml += isDisabled ? 'Sold Out' : 'Quick add';
              itemCartHtml += '</span></button>';
  
              /* end-boost-custom */
          }
        	itemCartHtml += '</div>';

        	
        } else {
           if(data.tags.includes('Coming Soon')){
               itemCartHtml += '<div class="product__grid__new_options">';
              itemCartHtml += '<div class="product-form__buttons coll_new_gr_cart_btn">';
              itemCartHtml += '<a href="{{itemUrl}}" class="btn_commoncls borderzero product-form__submit">Coming Soon</a>';
              itemCartHtml += '</div>';
          }else if(data.tags.includes('Request Pricing')){
            itemCartHtml += '<div class="product__grid__new_options">';
            itemCartHtml += '<div class="product-form__buttons coll_new_gr_cart_btn">';
            itemCartHtml += '<button type="button" name="add" class="btn_commoncls borderzero product-form__submit"><span>';
            itemCartHtml += 'Request Pricing';
            itemCartHtml += '</span></button>';
            itemCartHtml += '</div>';
          }else{
             itemCartHtml += '<div class="product__grid__new_options">';
              itemCartHtml += '<div class="product-form__buttons coll_new_gr_cart_btn">';
              itemCartHtml += '<button type="button" name="add" class="btn_commoncls borderzero product-form__submit" disabled><span>';
              itemCartHtml += 'Sold Out';
              itemCartHtml += '</span></button>';
              itemCartHtml += '</div>';
          }
        }
        itemCartHtml += '</div>';

		

		//BUILD PROGRESS BAR 
		 //let progressBar = buildProgressBar(data);
		 let progressBar = '';
		itemHtml = itemHtml.replace(/{{progressBar}}/g, progressBar);
      	itemHtml = itemHtml.replace(/{{itemCart}}/g, Utils.isSearchPage() ? '' : itemCartHtml);

		// Add main attribute (Always put at the end of this function)
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		const title = data.title + ' - ' + color;
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, title);
		const url = `${Utils.buildProductItemUrl(data)}?variant=${selectedVariant.id}`;
		itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
		itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, url);
		itemHtml = itemHtml.replace(/{{itemCustomSale}}/g, customSaleClass); 
		itemHtml = itemHtml.replace(/{{itemDeals}}/g, deals);  

		return itemHtml


	}

	/************************** END BUILD PRODUCT LIST **************************/
	function buildProgressBar(data) {
		let starting_inventory = data.metafields.find(item => item.key === "starting_inventory");
		let limit = data.metafields.find(item => item.key === "inventory_limit");
		let active = true;
		if(!starting_inventory || !data.compare_at_price_min){
			active = false;
		}
		if(limit){
			active = true;
		}
		if(!active){
			return "";
		}
        if(!starting_inventory ){
          return "";
        }
		let html = '';
    	let current_inventory = 0 
		data.variants.map((variant) => {
			current_inventory += variant.inventory_quantity
		})
		if(current_inventory < 0){
			current_inventory = 0
		}
		
    	let percentage = Math.round((current_inventory / starting_inventory.value) * 100)
		let progress = 100 - percentage;
		let bar_color = ''
		let percentage_bar = percentage;
		if(limit){
			current_inventory = 1 
			let sold = data.metafields.find(item => item.key === "total_sold");
			if(sold){
				current_inventory = sold.value;
			}
			
			percentage =  Math.round((current_inventory / limit.value) * 100);
            if(percentage > 99){
              percentage_bar = 100 - percentage;
  			progress = percentage ;
              percentage = 0
            }else{
              percentage_bar = 100 - percentage;
			progress = percentage;
            }
			
		}
		
		if(progress > 0){
			if (progress < 31){
				bar_color = 'green-health';
			}else if(progress< 61){
				bar_color = 'yellow-health';
			}
			if(progress < 99){
				html = `<div class="claim-bar bg-lightBlack px-[10px] py-[10px] w-full rounded-[5px] mb-[10px] ${bar_color}">
				<div class="progess-bar " >
					<span class="progress" style="width:${percentage_bar}%;"></span>
				</div>
				<div class="msg text-center ">
					<p class="m-auto text-[14px] mobile:text-[20px] holiday-body holiday-shadow white leading-none	"><span class="holiday-primary">${ progress}%</span> already claimed by other players</p>
				</div>
				</div>`;
			}else{ 
				html = `<div class="claim-bar bg-lightBlack px-[10px] py-[10px] w-full rounded-[5px] mb-[10px] ${bar_color}">
					<p class="m-0 h3 text-white text-center">GAME OVER</p>
				<div class="msg text-center ">
					<p class="m-auto text-[14px] mobile:text-[20px] holiday-body holiday-shadow white leading-none	"><span class="holiday-primary">${ 100 - percentage}%</span> already claimed by other players</p>
				</div>
				</div>`;
			}
		}	

		return html;
	}
	/************************** BUILD PRODUCT ITEM ELEMENTS **************************/
    function buildHoverImage(img){
          var html = '',
  			aspectRatio = '',
  			rangeWidths = boostPFSRangeWidths,
  			paddingBottom = 100;
          var dataSrcSet = '',
			imgAlt = img.alt,
			flipImageSrcSet = '';
            //dataSrcSet = Utils.optimizeImage(img['src'], rangeWidths + 'x') + ' ' + rangeWidths + 'w';
            html += '<img class="motion-reduce hover-collection"' +
				'loading="lazy"' +
				'height="' + img.height + '" ' +
				'width="' + img.width + '" ' +
				'sizes="(min-width: 1100px) 535px, (min-width: 750px) calc((100vw - 130px) / 2), calc((100vw - 50px) / 2)"' +
				'src="' + Utils.optimizeImage(img.src, '533x') + '" ' +
				'alt="' + imgAlt + '" />';
          return html;
    }
	function buildImages(data) {
		var html = '',
			aspectRatio = '',
			rangeWidths = boostPFSRangeWidths,
			paddingBottom = 100;

		var dataSrcSet = '',
			imgAlt = data.title,
			flipImageSrcSet = '';

		var activeSwapImage = !Utils.isMobile() && images.length > 1 &&
			boostPFSThemeConfig.custom.hasOwnProperty('show_secondary_image') &&
			boostPFSThemeConfig.custom.show_secondary_image == true;

		for (var i = 0; i < rangeWidths.length; i++) {
			dataSrcSet += Utils.getFeaturedImage(images, rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';

			if (activeSwapImage) {
				flipImageSrcSet += Utils.optimizeImage(images[1]['src'], rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';
			}

			if (i < rangeWidths.length - 1) {
				dataSrcSet += ', ';

				if (activeSwapImage) {
					flipImageSrcSet += ', ';
				}
			}
		}

		if (images.length > 0) {
			aspectRatio = images[0]['width'] / images[0]['height'];
			paddingBottom = 1 / aspectRatio * 100;

			html += '<div class="first_class__of_img"';
			if (boostPFSThemeConfig.custom.hasOwnProperty('add_image_padding') &&
				boostPFSThemeConfig.custom.add_image_padding === true) {
				html += ' class="card__media-full-spacer"';
			}
			html += '>';
			html += '<div class="media media--transparent media--';
			if (boostPFSThemeConfig.custom.hasOwnProperty('media_size')) {
				html += boostPFSThemeConfig.custom.media_size;
			}
			html += ' media--hover-effect"';
			if (boostPFSThemeConfig.custom.hasOwnProperty('media_size') &&
				boostPFSThemeConfig.custom.media_size == 'adapt' &&
				images.length > 0) {
				html += ' style="padding-bottom: ' + paddingBottom + '%"';
			}
			html += '>'
			html += '<img class="motion-reduce"' +
				'loading="lazy"' +
				'srcset="' + dataSrcSet + '" ' +
				'height="' + images[0].height + '" ' +
				'width="' + images[0].width + '" ' +
				'sizes="(min-width: 1100px) 535px, (min-width: 750px) calc((100vw - 130px) / 2), calc((100vw - 50px) / 2)"' +
				'src="' + Utils.optimizeImage(images[0].src, '533x') + '" ' +
				'alt="' + imgAlt + '" />';

			if (activeSwapImage) {
				html += '<img class="motion-reduce"' +
				'loading="lazy"' +
				'srcset="' + flipImageSrcSet + '" ' +
				'height="' + images[1].height + '" ' +
				'width="' + images[1].width + '" ' +
				'sizes="(min-width: 1100px) 535px, (min-width: 750px) calc((100vw - 130px) / 2), calc((100vw - 50px) / 2)"' +
				'src="' + Utils.optimizeImage(images[1].src, '533x') + '" ' +
				'alt="' + imgAlt + '" />';
			}
			html += '</div>';
			html += '</div>';
		} else {
			html += '<div class="card__content"><h2 class="card__text h2">' + data.title  + '</h2></div>'
		}
		return html;
	}

	function buildCardProductClass() {
		var html = '';
		if (!images || (images && images.length === 0)) {
			html = 'card--text-only card--soft';
		} else {
      html = 'card--outline';
    }
		return html;
	}

	function buildVendor(data) {
		var html = '';
		if (boostPFSThemeConfig.custom.hasOwnProperty('show_vendor') &&
			boostPFSThemeConfig.custom.show_vendor === true) {
			html = boostPFSTemplate.vendorHtml;
		}
		return html;
	}

	function buildPrice(data) {
      console.log(data)
		var html = '';
		var noComparePrice = data.price_varies === false && data.compare_at_price_varies;
		var moneyPrice = priceVaries ? boostPFSConfig.label.from_price_html.replace(/{{ price }}/, Utils.formatMoney(data.price_min))
			: Utils.formatMoney(data.price_min);
		var unitPriceClass = !data.available || typeof data?.selected_or_first_available_variant?.unit_price_measurement === 'undefined' ? 'hidden' : ''
        let hasStartingPrice = data.metafields.find(mf => mf.namespace === 'rep' && mf.key === 'starting_price');
      const productObject = productJson.find((item) => item.id === data.id);
        if(hasStartingPrice){
          let amount = JSON.parse(hasStartingPrice.value)
          html = `<em class="d_pargraph_9">Starting at</em><div class="price ${soldOut ? 'price--sold-out' : ''} ${onSale ? 'price--on-sale' : ''}${noComparePrice ? 'price--no-compare' : ''}"
					<dl>
						<div class="price__regular">
							<dt>
								<span class="visually-hidden visually-hidden--inline">
									${boostPFSConfig.label.regular_price}
								</span>
							</dt>
							<dd>
								<span class="price-item price-item--regular">
									$${amount.amount}
						  		</span>
							</dd>
						</div>
						<div class="price__sale">
							<dt class="price__compare">
								<span class="visually-hidden visually-hidden--inline">
									${Utils.formatMoney(data.sale_price)}
								</span>
							</dt>
							<dd class="price__compare">
								<s class="price-item price-item--regular pricea">
								${Utils.formatMoney(amount.amount)}
								</s>
						  	</dd>
							<dt>
							  <span class="visually-hidden visually-hidden--inline">${boostPFSConfig.label.sale_price}</span>
							</dt>
							<dd class="price__last">
								<span class="price-item price-item--sale">
									${moneyPrice}
								</span>
						  	</dd>
						</div>
						<small class="unit-price caption ${unitPriceClass}">
							<dt class="visually-hidden">${boostPFSConfig.label.unit_price}</dt>
							<dd class="price__last">
								<span>${Utils.formatMoney(data.selected_or_first_available_variant && data.selected_or_first_available_variant.unit_price)}</span>
								<span aria-hidden="true">/</span>
								<span class="visually-hidden">&nbsp;${boostPFSConfig.label.unit_price_separator}&nbsp;</span>
							</dd>
					  </small>
					</dl>
				</div>`
        }else{
          if(productObject){
            moneyPrice = Utils.formatMoney((productObject.price_min/100));
          }
          html = `<em class="d_pargraph_9">Starting at</em><div class="price ${soldOut ? 'price--sold-out' : ''} ${onSale ? 'price--on-sale' : ''}${noComparePrice ? 'price--no-compare' : ''}"
					<dl>
						<div class="price__regular">
							<dt>
								<span class="visually-hidden visually-hidden--inline">
									${boostPFSConfig.label.regular_price}
								</span>
							</dt>
							<dd>
								<span class="price-item price-item--regular">
									${moneyPrice}
						  		</span>
							</dd>
						</div>
						<div class="price__sale">
							<dt class="price__compare">
								<span class="visually-hidden visually-hidden--inline">
									${Utils.formatMoney(data.sale_price)}
								</span>
							</dt>
							<dd class="price__compare">
								<s class="price-item price-item--regular">
								${Utils.formatMoney(data.compare_at_price_min)}
								</s>
						  	</dd>
							<dt>
							  <span class="visually-hidden visually-hidden--inline">${boostPFSConfig.label.sale_price}</span>
							</dt>
							<dd class="price__last">
								<span class="price-item price-item--sale">
									${moneyPrice}
								</span>
						  	</dd>
						</div>
						<small class="unit-price caption ${unitPriceClass}">
							<dt class="visually-hidden">${boostPFSConfig.label.unit_price}</dt>
							<dd class="price__last">
								<span>${Utils.formatMoney(data.selected_or_first_available_variant && data.selected_or_first_available_variant.unit_price)}</span>
								<span aria-hidden="true">/</span>
								<span class="visually-hidden">&nbsp;${boostPFSConfig.label.unit_price_separator}&nbsp;</span>
							</dd>
					  </small>
					</dl>
				</div>`
        }
      
		
		return html;
	}

	function buildSoldOutLabel() {
		// Build Sold out label
		var soldOutLabel = '';
		if (boostPFSThemeConfig.custom.hasOwnProperty('sold_out_badge_color_scheme') && soldOut) {
			soldOutLabel = boostPFSTemplate.soldOutLabelHtml.replace(/{{soldOutBadgeClass}}/g, boostPFSThemeConfig.custom.sold_out_badge_color_scheme);
		}
		return soldOutLabel;
	}

	function buildSaleLabel() {
		// Build Sale label
		var saleLabel = '';
		if (boostPFSThemeConfig.custom.hasOwnProperty('sale_badge_color_scheme') && onSale && !soldOut) {
			saleLabel = boostPFSTemplate.saleLabelHtml.replace(/{{saleBadgeClass}}/g, boostPFSThemeConfig.custom.sale_badge_color_scheme);
		}
		return saleLabel;
	}

	function buildReview(data) {
		var html = '';
		if (boostPFSThemeConfig.custom.hasOwnProperty('show_product_review') &&
			boostPFSThemeConfig.custom.show_product_review == true && Utils.getProductMetafield(data, 'reviews', 'rating') !== null) {
			var ratingObj = JSON.parse(Utils.getProductMetafield(data, 'reviews', 'rating'));
      var rating_decimal = 0;
      var decimal = parseFloat(ratingObj.value.rating);
      if (decimal >=0.3 && decimal <= 0.7) {
        rating_decimal = 0.5;
      } else if (decimal > 0.7) {
        rating_decimal = 1;
      }
      html = `<div class="yotpo-widget-instance" data-yotpo-instance-id="386611" data-yotpo-product-id="{{data.id}}" data-yotpo-cart-product-id="{{data.id}}" data-yotpo-section-id="collection"></div>`
      // html = `<div class="rating" role="img" aria-label="${boostPFSConfig.label.star_reviews_info.replace('{{ rating_value }}', ratingObj.value).replace('{{ rating_max }}', ratingObj.value.scale_max)}">
      //           <span aria-hidden="true" class="rating-star color-icon-${boostPFSConfig.custom.accent_icons}" style="--rating: ${Math.round(ratingObj.value.rating)}; --rating-max: ${ratingObj.value.scale_max}; --rating-decimal: ${rating_decimal};"></span>
      //         </div>
      //         <p class="rating-text caption">
      //           <span aria-hidden="true">${ratingObj.value} / ${ratingObj.value.scale_max}</span>
      //         </p>
      //         <p class="rating-count caption">
      //           <span aria-hidden="true">(${Utils.getProductMetafield(data, 'reviews', 'rating_count')})</span>
      //           <span class="visually-hidden">${Utils.getProductMetafield(data, 'reviews', 'rating_count')} ${boostPFSConfig.label.total_reviews}</span>
      //         </p>`;
		}
		return html;
	}

	/************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
	/************************** BUILD TOOLBAR **************************/
	// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct;
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
		// If it has only one page, clear Pagination
		if (totalPage <= 1) {
			return '';
		}

		var paginationHtml = boostPFSTemplate.paginateHtml;
		// Build Previous
		var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : '';
		previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
		paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
		// Build Next
		var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : '';
		nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
		paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
		// Create page items array
		var beforeCurrentPageArr = [];
		for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
			beforeCurrentPageArr.unshift(iBefore);
		}
		if (currentPage - 4 > 0) {
			beforeCurrentPageArr.unshift('...');
		}
		if (currentPage - 4 >= 0) {
			beforeCurrentPageArr.unshift(1);
		}
		beforeCurrentPageArr.push(currentPage);
		var afterCurrentPageArr = [];
		for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
			afterCurrentPageArr.push(iAfter);
		}
		if (currentPage + 3 < totalPage) {
			afterCurrentPageArr.push('...');
		}
		if (currentPage + 3 <= totalPage) {
			afterCurrentPageArr.push(totalPage);
		}
		// Build page items
		var pageItemsHtml = '';
		var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
		for (var iPage = 0; iPage < pageArr.length; iPage++) {
			if (pageArr[iPage] == '...') {
				pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
			} else {
				pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
			}
			pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
			pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
		}
		paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
		return paginationHtml;
	};
  
	// Build Sorting
	ProductSorting.prototype.compileTemplate = function() {
		var html = '';
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				var paramSort = Globals.queryParams.sort || '';
              
				// Build content
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					activeClass = '';
					if (paramSort == k) {
						activeClass = 'boost-pfs-filter-sort-item-active';
					}
					sortingItemsHtml += '<li aria-label="' + sortingArr[k] + '"><a href="#" data-sort="' + k + '" class="' + activeClass + '"  title="' + sortingArr[k] + '" aria-label="' + sortingArr[k] + '">' + sortingArr[k] + '</a></li>';
				}
				html = boostPFSTemplate.sortingHtml2.replace(/{{sortingItems}}/g, sortingItemsHtml);
			}
		return html;
	};

	ProductSorting.prototype.render = function() {
		jQ(Selector.topSorting).html(this.compileTemplate());

		if (jQ('.boost-pfs-filter-custom-sorting').hasClass('boost-pfs-filter-sort-active')) {
			jQ('.boost-pfs-filter-custom-sorting').toggleClass('boost-pfs-filter-sort-active');
		}

		var labelSort = '';
		var paramSort = Globals.queryParams.sort || '';
		var sortingList = Utils.getSortingList();
		if (paramSort.length > 0 && sortingList && sortingList[paramSort]) {
			labelSort = sortingList[paramSort];
		} else {
			labelSort = Labels.sorting_heading;
		}

		jQ('.boost-pfs-filter-custom-sorting button span span').text(labelSort);
	}

	// Build Sorting event
	ProductSorting.prototype.bindEvents = function() {
		var _this = this;
		jQ('.boost-pfs-filter-filter-dropdown a').click(function(e) {
			e.preventDefault();
			FilterApi.setParam('sort', jQ(this).data('sort'));
			FilterApi.setParam('page', 1);
			FilterApi.applyFilter('sort');
		});

		jQ(".boost-pfs-filter-custom-sorting > button").click(function() {
      jQ('.boost-pfs-filter-filter-dropdown').toggle().parent().toggleClass('boost-pfs-filter-sort-active');
		});

		jQ(Selector.filterTreeMobileButton).click(function() {
			jQ('.boost-pfs-filter-top-sorting-mobile .boost-pfs-filter-filter-dropdown').hide();
		});

		jQ(document).on('click', function (e) {
      if (jQ(e.target).parents('.boost-pfs-filter-top-sorting').find(".boost-pfs-filter-filter-dropdown").length === 0) {
      	jQ('.boost-pfs-filter-filter-dropdown').hide().parent().removeClass('boost-pfs-filter-sort-active');
      }
    });
           ProductSorting.prototype.afterRender = function() {
        var sortItems = document.querySelectorAll('.boost-custom-sort-by-mobile a');
        
        sortItems.forEach(function(item) {
          if (jQ(item).attr("data-sort") === Globals.queryParams.sort) {
          	jQ(item).addClass('active');
            jQ(item).removeClass('inactive');
          } else {
            jQ(item).removeClass('active');
            jQ(item).addClass('inactive');
          }
        });
      }
	};  
  

// 	// Build Sorting
// 	ProductSorting.prototype.compileTemplate = function () {
// 		var html = '';
// 		if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
// 			var sortingArr = Utils.getSortingList();
// 			if (sortingArr) {
// 				var paramSort = Globals.queryParams.sort || '';
// 				// Build content
// 				var sortingItemsHtml = '';
// 				for (var k in sortingArr) {
// 					var isSelected = ''
// 					if(paramSort == k) {
// 						isSelected = 'selected="selected"'
// 					}
// 					sortingItemsHtml += '<option value="' + k + '"' + isSelected + '>' + sortingArr[k] + '</option>';
// 				}
// 				html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
// 			}
// 		}
// 		return html;
// 	};

// 	ProductSorting.prototype.render = function () {
// 		jQ(Selector.topSorting).html(this.compileTemplate());

// 		if (jQ('.boost-pfs-filter-custom-sorting').hasClass('boost-pfs-filter-sort-active')) {
// 			jQ('.boost-pfs-filter-custom-sorting').toggleClass('boost-pfs-filter-sort-active');
// 		}

// 		var labelSort = '';
// 		var paramSort = Globals.queryParams.sort || '';
// 		var sortingList = Utils.getSortingList();
// 		if (paramSort.length > 0 && sortingList && sortingList[paramSort]) {
// 			labelSort = sortingList[paramSort];
// 		} else {
// 			labelSort = Labels.sorting;
// 		}

// 		jQ('.boost-pfs-filter-custom-sorting button span span').text(labelSort);
// 	}

// 	// Build Sorting event
// 	ProductSorting.prototype.bindEvents = function() {
// 		jQ('.collection-filters__sort').change(function(e) {
// 			e.preventDefault();
// 			FilterApi.setParam('sort', jQ(this).val());
// 			FilterApi.setParam('page', 1);
// 			FilterApi.applyFilter('sort');
// 		});
// 	};

  // Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function(data) {
		if (!data) data = this.data;
		let cta = Settings.general.collection_cta
        let position = Settings.general.collection_cta_position ;
        cta = false;
		if(cta){
			let bgStyle = "";
			if('bg' in cta){
				bgStyle = `style="background-image:url(${cta.bg});"`;
			}
			let item = `<div class="grid__item flex flex-col justify-evenly bg-cover bg-no-repeat  quiz-item bg-[#1A1C28] text-center px-4 py-10" ${bgStyle}><h2 class="uppercase text-white h2 text-center !mb-0">${cta.title}</h2><div class="opacity-75 spacer bg-white h-[1px] w-full !block "></div><div class="cta-content w-full">`;
			if('links' in cta){
				cta.links.map((link, index) => {
					let btnClass = "btn-invert bg-white";
					if(index > 0){
						btnClass = "btn-invert-outline";
					}
					item +=  `<div class="cta-link w-full mb-[15px]"><a href="${link.url}" class="${btnClass} !w-full">${link.title}</a></div>`;
				})
			}
			item +=  `</div></div>`;
            if(!position){
              this.$element.append(item)
            }else{
              this.$element.append(item)
              let element = this.$element[0]
              let index = position - 1;
              let last = element.lastChild
              element.insertBefore(last,element.childNodes[index]);
              // console.log(this.$element)
              // console.log(this.$element[0])
              // this.$element[0].insertBefore(item, this.$element[0].childNodes[index]);
            }
			
		}
		
      	// Quick View and ATC
//         this.buildExtrasProductListByAjax(data, 'boost-pfs-theme-quickview', function(results) {
//             results.forEach(function(result) {
//                 var element = '';
//                 element = jQ('[data-boost-theme-quickview="' + result.id + '"] div.product__grid_new_image');
//                 element.append(result.quickview.trim());
//             });
//             jQ('.product__color_option_ul li div.pro__var_div').on('click', function(e) {
//               console.log('12');
//               var variantId = jQ(this).find('.short_cut_add_tocart').data('id');
//               console.log(variantId);
//               jQ(this).parents('.product__grid__new_options').find('.product-form__buttons .short_cut_add_tocart').attr('data-id', variantId);
//             });
//         });
	}

	// Build Additional Elements
	Filter.prototype.afterRender = function(data, eventType) {
		if (!data) data = this.data;
		jQ('.boost-pfs-filter-total-product').html(data.total_product + ' products');
      
        //Add to Cart
      	addToCart();
      
        jQ(".pro__var_div").on('click', function(e) {
          var short_cut_add_tocart__collection_list = $(this).find('.short_cut_add_tocart__collection').attr("data-image");
          var short_cut_add_tocart__collection_list_id = $(this).find('.short_cut_add_tocart__collection').attr("data-id");
          jQ(this).parents('.product_grid_new_ingrid').find('.product__grid_new_image_image img').attr('src', short_cut_add_tocart__collection_list);
          jQ(this).parents('.product_grid_new_ingrid').find('.product-form__buttons  .short_cut_add_tocart').attr('data-id', short_cut_add_tocart__collection_list_id);
        });
      
      var cadPrefix = '';
      if (boostPFSConfig.general.current_currency == 'CAD') {
            cadPrefix =  'CAD';
          $('.price-item').each(function(index, value) {
            var currentHtml = $(this).html();
            if(!currentHtml.includes("<span>CAD</span>")) {
              $(this).prepend("<span>CAD</span>");
            }
      	  });
      }	
	};

	/************************** END BUILD TOOLBAR **************************/
    FilterRefineBy.prototype.afterRender = function(){
      if (this.$element != null){
        this.$element.find('span').first().addClass('boost-refine-by-btn');
      }
    }

	FilterApi.beforeCall = function(eventType, eventInfo) { 
      console.log(Globals.queryParams.return_all_currency_fields)
    }
   
  
    FilterTree.prototype.afterBindEvents = function (){
      if (Utils.isMobile() && this.$element != null){
        if (this.$element.find('.boost-custom-sort-by-mobile').length == 0) {
          this.$element.find('.boost-pfs-filter-options-wrapper').append('<div class="boost-custom-sort-by-mobile"><div class="boost-pfs-filter-toolbar-item boost-pfs-filter-custom-sorting boost-pfs-filter-top-sorting boost-pfs-filter-sort-active boost-pfs-custom-active"></div></div>');
          var htmlSort = '';
          var sortingArr = Utils.getSortingList();
          if (sortingArr) {
            var paramSort = Globals.queryParams.sort || '';
            // Build content
            var sortingItemsHtml = '';
            for (var k in sortingArr) {
              activeClass = '';
              if (paramSort == k) {
                activeClass = 'boost-pfs-filter-sort-item-active';
              }
              sortingItemsHtml += '<li aria-label="' + sortingArr[k] + '"><span class="boost-pfs-sorting-checkbox"></span><a href="#" data-sort="' + k + '" class="' + activeClass + '"  title="' + sortingArr[k] + '" aria-label="' + sortingArr[k] + '">' + sortingArr[k] + '</a></li>';
            }
            htmlSort = boostPFSTemplate.sortingHtml2.replace(/{{sortingItems}}/g, sortingItemsHtml);
          }
          jQ(Selector.topSorting).html(htmlSort);

          if (jQ('.boost-pfs-filter-custom-sorting').hasClass('boost-pfs-filter-sort-active')) {
            jQ('.boost-pfs-filter-custom-sorting').toggleClass('boost-pfs-filter-sort-active');
          }

          var labelSort = '';
          var paramSort = Globals.queryParams.sort || '';
          var sortingList = Utils.getSortingList();
          if (paramSort.length > 0 && sortingList && sortingList[paramSort]) {
            labelSort = sortingList[paramSort];
          } else {
            labelSort = Labels.sorting_heading;
          }

          jQ('.boost-pfs-filter-custom-sorting button span span').text(labelSort);
        }
      }
    }
    // Add to Cart
    function addToCart() {
      jQ(window).on('click', '.short_cut_add_tocart', function(){
        var itemId = jQ(this).closest('.product_grid_new').find('.product__grid__new_options li.active > .pro__var_div > div').attr('data-id');
        var formData = {
          'items': [{
            'id': itemId,
            'quantity': 1
          }]
        };
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: JSON.stringify(formData),
          dataType: 'json',
          contentType: 'application/json',
          success: function(cart){
            ajaxCart.load(); // update cart 
            if (!jQ('body').hasClass('CartOpen')) {
              $('.shoppingcart').trigger('click'); // open cart
            }
          },
          error: function(XMLHttpRequest, textStatus){
            var data = eval('('+XMLHttpRequest.responseText+')');
            alert(data.description);

          }
        });     
      });
    }

  function isMultipleOption(data){
    if(data.options_with_values.length > 1){
      return true;
    }
    return false;
  }

  jQ(document).on('click','.product__color_option_ul li',function(){
    jQ(this).parent().find('li').removeClass('active');
    jQ(this).addClass('active');
  });

     /* Start-Boost-Reduce-Price-Params */
    FilterApi.beforeCall = function(eventType, eventInfo) { 
        Globals.queryParams.country = Shopify.country;
        Globals.queryParams.currency = boostPFSConfig.general.current_currency.toLowerCase();
        Globals.queryParams.currency_rate = Shopify.currency.rate;
        Globals.queryParams.return_all_currency_fields = false;
    }
    /* End-Boost-Reduce-Price-Params */
  
})();
